import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import genericArraySorter from "../../../../Utilities/genericArraySorter";
import "./EconomyReportStyles.css";

const MoneyDistributionChart = ({ list, languageData }) => {
  var colorArray = [
    "#FF6633",
    "#FFB399",
    "#FF33FF",
    "#00B3E6",
    "#E6B333",
    "#3366E6",
    "#999966",
    "#99FF99",
    "#B34D4D",
    "#80B300",
    "#809900",
    "#E6B3B3",
    "#6680B3",
    "#66991A",
    "#FF99E6",
    "#CCFF1A",
    "#FF1A66",
    "#E6331A",
    "#33FFCC",
    "#66994D",
    "#B366CC",
    "#4D8000",
    "#B33300",
    "#CC80CC",
    "#66664D",
    "#991AFF",
    "#E666FF",
    "#4DB3FF",
    "#1AB399",
    "#E666B3",
    "#33991A",
    "#CC9999",
    "#B3B31A",
    "#00E680",
    "#4D8066",
    "#809980",
    "#E6FF80",
    "#1AFF33",
    "#999933",
    "#FF3380",
    "#CCCC00",
    "#66E64D",
    "#4D80CC",
    "#9900B3",
    "#E64D66",
    "#4DB380",
    "#FF4D4D",
    "#99E6E6",
    "#6666FF",
  ];
  const [formattedData, setFormattedData] = useState({});
  const [innerData, setInnerData] = useState([]);
  const [outerData, setOuterData] = useState([]);
  const [clickedSector, setClickedSector] = useState("");
  const [selectedPart, setSelectedPart] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [productsBySubcat, setProductsBySubcat] = useState({});
  const [expandedSector, setExpandedSector] = useState("");

  const generatePriceChartData = () => {
    let tempData = {};
    let tempProdsBySubcat = {};
    list.forEach((item) => {
      if (item.average_price) {
        let price =
          +Number.parseFloat(item.average_price).toFixed(0) * item.quantity;

        if (tempData[item.cat_name] && tempData[item.cat_id] !== "") {
          // CHECK IF ITEM CATEGORY EXISTS IN OUR DATA OBJECT
          tempData[item.cat_name].total += 1;
          tempData[item.cat_name].priceSum += price;

          if (tempData[item.cat_name][item.subcat_name]) {
            // CHECK IF ITEM SUB CATEGORY EXISTS IN OUR DATA OBJECT
            tempData[item.cat_name][item.subcat_name].value += 1;
            tempData[item.cat_name][item.subcat_name].priceSum += price;
            tempData[item.cat_name][item.subcat_name].products.push(item);
          } else {
            tempData[item.cat_name][item.subcat_name] = {
              value: 1,
              priceSum: price,
              color: tempData[item.cat_name]["color"],
              products: [item],
            };
          }
        } else if (item.cat_id !== "" && item.average_price) {
          let newColor = colorArray.pop();
          tempData[item.cat_name] = {
            total: 1,
            priceSum: price,
            color: newColor,
          };
          tempData[item.cat_name][item.subcat_name] = {
            value: 1,
            priceSum: price,
            color: newColor,
            products: [item],
          };
        }
      }
    });

    let innerDataList = [];
    let outerDataList = [];
    let tempTotalPrice = 0;
    Object.keys(tempData).forEach((cat) => {
      tempTotalPrice += tempData[cat].priceSum;
      innerDataList.push({
        name: cat,
        value: tempData[cat].priceSum,
        color: tempData[cat].color,
        priceSum: tempData[cat].priceSum,
      });
      Object.keys(tempData[cat]).forEach((subcat) => {
        if (subcat !== "total" && subcat !== "color" && subcat !== "priceSum") {
          tempProdsBySubcat[subcat] = tempData[cat][subcat].products;
          outerDataList.push({
            name: subcat,
            value: tempData[cat][subcat].priceSum,
            color: tempData[cat][subcat].color,
            priceSum: tempData[cat][subcat].priceSum,
          });
        }
      });
    });
    setProductsBySubcat(tempProdsBySubcat);
    setFormattedData(tempData);
    setTotalPrice(tempTotalPrice);
    setInnerData(innerDataList);
    setOuterData(outerDataList);
    console.log(tempData);
  };

  const generateSubCatData = () => {
    let innerDataList = [
      {
        name: selectedPart.name,
        value: selectedPart.priceSum,
        color: selectedPart.color,
        priceSum: selectedPart.priceSum,
      },
    ];

    let outerDataList = [];
    Object.keys(formattedData[selectedPart.name]).forEach((subcat, index) => {
      if (subcat !== "total" && subcat !== "color" && subcat !== "priceSum") {
        outerDataList.push({
          name: subcat,
          value: formattedData[selectedPart.name][subcat].priceSum,
          color: colorArray[index],
          priceSum: formattedData[selectedPart.name][subcat].priceSum,
        });
      }
    });
    setTotalPrice(selectedPart.priceSum);
    setInnerData(innerDataList);
    setOuterData(outerDataList);
  };

  const handleSelectPart = (part) => {
    setSelectedPart(part);
    setClickedSector("");
  };

  useEffect(() => {
    if (selectedPart === "") {
      generatePriceChartData();
    } else {
      generateSubCatData();
    }
  }, [selectedPart]);

  return (
    <React.Fragment>
      {Object.keys(innerData).length > 0 && (
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div id="moneyCategoryBox">
            {selectedPart !== "" && (
              <div
                className="tinyCircle"
                style={{ backgroundColor: selectedPart.color }}
              />
            )}
            <h5 id="moneyCategory">
              {selectedPart === "" ? "All categories" : selectedPart.name}
            </h5>
          </div>
          <div id="moneySpentBox">
            <p id="totalMoneyText">Total value: </p>
            <p id="totalMoneySum">{`${totalPrice} SEK`}</p>
          </div>
          {selectedPart !== "" && (
            <button id="economyBackBtn" onClick={() => handleSelectPart("")}>
              <img
                src={require("../../../../Images/Icons/back.svg")}
                alt="backIcon"
                className="backBtnIcon"
              />
            </button>
          )}
          <ResponsiveContainer width={"100%"} height={275} minHeight={250}>
            <PieChart width={350} height={275}>
              {/*<Legend formatter={renderColorfulLegendText} />*/}
              <Pie
                data={innerData}
                cx={"50%"}
                cy={"50%"}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                nameKey="name"
                animationBegin={400}
              >
                {" "}
                {innerData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    stroke={clickedSector === entry ? "black" : "white"}
                    strokeWidth={clickedSector === entry ? 2 : 1}
                    onClick={() => setClickedSector(entry)}
                  />
                ))}
              </Pie>
              <Pie
                data={outerData}
                dataKey="value"
                nameKey="name"
                cx={"50%"}
                cy={"50%"}
                innerRadius={90}
                outerRadius={130}
                fill="#82ca9d"
                animationBegin={500}
              >
                {outerData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    stroke={clickedSector === entry ? "black" : "white"}
                    strokeWidth={clickedSector === entry ? 2 : 1}
                    onClick={() => setClickedSector(entry)}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          {clickedSector !== "" && (
            <div id="clickedSectorRow">
              <div
                className="tinyCircle"
                style={{ backgroundColor: clickedSector.color }}
              />
              <p className="piePartDescriptionText">
                {clickedSector.name}
                {clickedSector.priceSum &&
                  ` (Ca ${clickedSector.priceSum.toFixed(2)} SEK)`}
              </p>
            </div>
          )}
        </div>
      )}
      <div
        id="pieChartLegend"
        style={{ marginTop: selectedPart !== "" && "15px" }}
      >
        {selectedPart === "" && (
          <p id="pieChartLegendHelperText">
            Click a category to show more details
          </p>
        )}
        {genericArraySorter(
          selectedPart === "" ? [...innerData] : [...outerData],
          "priceSum"
        ).map((element, index) => {
          return (
            <div
              className="piePartDescriptionRow"
              onClick={() =>
                selectedPart === ""
                  ? handleSelectPart(element)
                  : expandedSector === element.name
                  ? setExpandedSector("")
                  : setExpandedSector(element.name)
              }
              key={`piePartRow-${index}`}
              style={{
                backgroundColor:
                  clickedSector === element
                    ? "darkgray"
                    : index % 2 === 0
                    ? "rgba(0, 0, 0, 0.1)"
                    : "white",
              }}
            >
              <span className="piePartTitleContainer">
                <span className="piePartTitleWrapper">
                  <div
                    className="tinyCircle"
                    style={{ backgroundColor: element.color }}
                  />
                  <p className="piePartDescriptionText">
                    {`${element.name}  (${(
                      (element.value / totalPrice) *
                      100
                    ).toFixed(2)}%)`}
                  </p>
                </span>
                <div className="pieChartLegendTag">
                  <p className="priceTagText">{`${element.priceSum.toFixed(
                    0
                  )} SEK`}</p>
                </div>
              </span>
              {expandedSector === element.name && (
                <div className="subcatProductList">
                  {productsBySubcat[element.name].map((item) => {
                    return (
                      <div className="subcatProductRow">
                        <p className="subcatProductRowText">{item.name} </p>
                        <p className="subcatProductRowPrice">
                          {parseFloat(item.average_price).toFixed(0)} SEK
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default MoneyDistributionChart;
